module.exports = __webpack_public_path__ + "img/56_lg.9cdd1409.jpg";